import { DashboardObjectDto } from 'src/models/account';
import processDashboardComponents from './processDashboardComponents';

export default (dashboardObject: DashboardObjectDto) => {
  if (!dashboardObject) return;

  return {
    ...dashboardObject,
    dashboardComponents: processDashboardComponents(dashboardObject?.dashboardComponents ?? [])
  };
};
